import { faArrowLeft, faBookmark as faBookmarkSolid, faCheck as faCheckSolid, faCheckCircle as faCheckCircleSolid, faCircle, faExclamationCircle as faExclamationCircleSolid, faFlagAlt, faMinus as faMinusSolid, faRobot, faSpinner, faUser as faUserSolid, } from '@fortawesome/pro-solid-svg-icons';
import { faCheckCircle as faCheckCircleRegular, faClone, faFlagAlt as faFlagAltRegular, faStar, } from '@fortawesome/pro-regular-svg-icons';
import { faAngleRight, faArrowCircleUp, faArrowToBottom, faArrowToTop, faBookmark, faCalendarAlt, faChartLine, faCheck, faCheckCircle, faChevronDown, faCircleNotch, faClipboard, faCode, faCodeMerge, faCog, faComment, faComments, faEdit, faEllipsisH, faEllipsisV, faExclamationCircle, faFileCheck, faHighlighter, faImage, faInbox, faInfoCircle, faLightbulb, faLightbulbOn, faLocation, faLongArrowRight, faMinus, faMousePointer, faPaperclip, faPaperPlane, faPen, faPlus, faPlusCircle, faSave, faSearch, faSearchMinus, faServer, faShareAlt, faSitemap, faSlidersH, faSortAmountDown, faSpinnerThird, faSync, faTachometerAlt, faTags, faTimes, faTimesCircle, faTrashAlt, faUndo, faUser, } from '@fortawesome/pro-light-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
export var icons = [
    faAngleRight,
    faArrowCircleUp,
    faArrowLeft,
    faArrowToBottom,
    faArrowToTop,
    faBookmark,
    faBookmarkSolid,
    faCalendarAlt,
    faChartLine,
    faCheck,
    faCheckCircle,
    faCheckCircleRegular,
    faCheckCircleSolid,
    faCheckSolid,
    faChevronDown,
    faCircle,
    faCircleNotch,
    faClipboard,
    faClone,
    faCode,
    faCodeMerge,
    faCog,
    faComment,
    faComments,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faExclamationCircle,
    faExclamationCircleSolid,
    faFileCheck,
    faFlagAlt,
    faFlagAltRegular,
    faHighlighter,
    faImage,
    faInbox,
    faInfoCircle,
    faLightbulb,
    faLightbulbOn,
    faLocation,
    faLongArrowRight,
    faMinus,
    faMinusSolid,
    faMousePointer,
    faPaperclip,
    faPaperPlane,
    faPen,
    faPlus,
    faPlusCircle,
    faRobot,
    faSave,
    faSearch,
    faSearchMinus,
    faServer,
    faShareAlt,
    faSitemap,
    faSlidersH,
    faSortAmountDown,
    faSpinner,
    faSpinnerThird,
    faStar,
    faSync,
    faTachometerAlt,
    faTags,
    faTimes,
    faTimesCircle,
    faTrashAlt,
    faUndo,
    faUser,
    faUserSolid,
];
export default function initializeIcons() {
    library.add.apply(library, icons);
}
